import styled from 'styled-components';
import { useSearchParam } from 'react-use';

import { FolderId } from 'modules/domains/foldering';
import { JourneySubfolder } from 'modules/domains/journey';

import { FolderClosed } from 'ui/icons';
import { FolderRow } from 'ui/indexPages/folders/folderRow';
import { SearchParamLink } from 'ui/utility/SearchParamLink/SearchParamLink';
import { SearchableText } from 'ui-beta/searchableText';

import { QUERY_PARAMS, SELECTABLE_ITEM_TYPE } from '../../constants';

import { WorkflowFolderRowOverflowMenu } from './WorkflowFolderRowOverflowMenu';
import { CheckboxCell } from './CheckboxCell';

type WorkflowRowProps = {
  folder: JourneySubfolder;
  onDeleteOptionClick: (folderId: FolderId) => void;
  onMoveOptionClick: (folderId: FolderId) => void;
  onRenameOptionClick: (folderId: FolderId) => void;
  onCreateOptionClick: (folderId: FolderId) => void;
};

const FolderLabel = styled(SearchParamLink)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const WorkflowFolderRow = ({
  folder,
  onDeleteOptionClick,
  onMoveOptionClick,
  onRenameOptionClick,
  onCreateOptionClick,
}: WorkflowRowProps) => (
  <FolderRow id={folder.id.toString()}>
    <CheckboxCell itemType={SELECTABLE_ITEM_TYPE.WORKFLOW_FOLDER} itemId={folder.id} />

    <FolderClosed />
    <FolderLabel
      /** Whenever we are navigating to a new folder, we always want to start on the first page. */
      searchParams={{ [QUERY_PARAMS.FOLDER_ID]: folder.id.toString(), [QUERY_PARAMS.PAGE]: '1' }}
    >
      <SearchableText
        isCaseSensitive={false}
        text={folder.name}
        searchText={useSearchParam(QUERY_PARAMS.SEARCH) || ''}
      />
    </FolderLabel>
    <WorkflowFolderRowOverflowMenu
      folder={folder}
      onDeleteOptionClick={onDeleteOptionClick}
      onMoveOptionClick={onMoveOptionClick}
      onRenameOptionClick={onRenameOptionClick}
      onCreateOptionClick={onCreateOptionClick}
    />
  </FolderRow>
);
